import type { SvgIconComponent } from '@mui/icons-material'
import { Grid, styled, Typography } from '@mui/material'
import type { ReactNode } from 'react'

export interface IconHeaderIndicatorProps {
  icon: SvgIconComponent
  title: string
  children?: ReactNode
}

const StyledHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey['700'],
  fontFamily: 'Geist Mono, monospaced',
  fontSize: '0.9em',
  fontStyle: 'normal',
  fontWeight: 400,
  letterSpacing: '0.02em',
  lineHeight: 'normal'
}))

export function IconHeaderIndicator({
  icon: Icon,
  title,
  children
}: IconHeaderIndicatorProps) {
  return (
    <Grid container direction="column" spacing={1.5}>
      <Icon sx={{ height: '1.7em', width: '1.7em', color: 'grey.500' }} />

      <Grid container direction="column" spacing={0.5}>
        <StyledHeader>{title}</StyledHeader>
        {children}
      </Grid>
    </Grid>
  )
}
